define(["require", "exports", "tslib"], function (require, exports, tslib_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.seconds = exports.minutes = exports.hours = exports.wait = exports.TimeUtil = void 0;
    class TimeUtil {
        static getLastDayOfAustralianFiscalYear(date) {
            const tentativeDate = new Date(date.getFullYear(), 5, 30);
            if (date.valueOf() < tentativeDate.valueOf()) {
                return tentativeDate;
            }
            else if (date.valueOf() > tentativeDate.valueOf()) {
                return new Date(date.getFullYear() + 1, 5, 30);
            }
            else {
                return date;
            }
        }
        static getFirstDayOfForthcomingAustralianFiscalYear(date) {
            const tentativeDate = new Date(date.getFullYear(), 6, 1);
            if (date.valueOf() < tentativeDate.valueOf()) {
                return tentativeDate;
            }
            else if (date.valueOf() > tentativeDate.valueOf()) {
                return new Date(date.getFullYear() + 1, 6, 1);
            }
            else {
                return date;
            }
        }
        static getJuly1stFiscalYearQuarter(date) {
            return Math.ceil((date.getMonth() + (21 - (6 - 1))) / 3) % 4 + 1;
        }
    }
    exports.TimeUtil = TimeUtil;
    function wait(duration = 1000) {
        return new Promise((resolve) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            setTimeout(() => {
                resolve();
            }, duration);
        }));
    }
    exports.wait = wait;
    function hours(hours = 1) {
        return hours * minutes(60);
    }
    exports.hours = hours;
    function minutes(minutes = 1) {
        return minutes * seconds(60);
    }
    exports.minutes = minutes;
    function seconds(seconds = 60) {
        return seconds * 1000;
    }
    exports.seconds = seconds;
});
